import { render, staticRenderFns } from "./gsNewsList.vue?vue&type=template&id=6b2c06ec&scoped=true"
import script from "./gsNewsList.vue?vue&type=script&lang=js"
export * from "./gsNewsList.vue?vue&type=script&lang=js"
import style0 from "./gsNewsList.vue?vue&type=style&index=0&id=6b2c06ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c06ec",
  null
  
)

export default component.exports